export default "/_next/static/images/weekly-report-avatar-48d8e4dcf8acc00f0419f288d53a8179.png";